import { c as _c } from "react/compiler-runtime";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import AutoSuggest from 'react-autosuggest';
import { debounce } from 'lodash';
import LabeledTextInput from 'components/consumer/LabeledTextInput';
import { USAutocompleteProApi } from './utils';
const BaseField = t0 => {
  const $ = _c(29);
  const {
    setFieldValue,
    field,
    errorMessage,
    refField,
    addressFieldName: t1,
    stateFieldName: t2,
    cityFieldName: t3,
    zipCodeFieldName: t4,
    ...props
  } = t0;
  const addressFieldName = t1 === undefined ? "address" : t1;
  const stateFieldName = t2 === undefined ? "state" : t2;
  const cityFieldName = t3 === undefined ? "city" : t3;
  const zipCodeFieldName = t4 === undefined ? "zipcode" : t4;
  let t5;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = [];
    $[0] = t5;
  } else {
    t5 = $[0];
  }
  const [suggestions, setSuggestions] = useState(t5);
  let t6;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setSuggestions([]);
    $[1] = t6;
  } else {
    t6 = $[1];
  }
  const clearSuggestions = t6;
  let t7;
  if ($[2] !== addressFieldName || $[3] !== cityFieldName || $[4] !== setFieldValue || $[5] !== stateFieldName || $[6] !== zipCodeFieldName) {
    t7 = (event, t8) => {
      const {
        suggestion
      } = t8;
      event.preventDefault();
      setFieldValue(addressFieldName, suggestion?.street_line);
      setFieldValue(stateFieldName, suggestion?.state);
      setFieldValue(cityFieldName, suggestion?.city);
      setFieldValue(zipCodeFieldName, suggestion?.zipcode);
    };
    $[2] = addressFieldName;
    $[3] = cityFieldName;
    $[4] = setFieldValue;
    $[5] = stateFieldName;
    $[6] = zipCodeFieldName;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const onSuggestionSelected = t7;
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = debounce(t9 => {
      const {
        value
      } = t9;
      USAutocompleteProApi(value).then(uniqSuggestions => {
        setSuggestions(uniqSuggestions);
      }).catch(() => {
        setSuggestions([]);
      });
    }, 300);
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  const onSuggestionsFetchRequested = t8;
  const concatenateAddressFields = _temp;
  const T0 = AutoSuggest;
  const t9 = false;
  const t10 = _temp2;
  const t11 = _temp3;
  let t12;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = suggestion_2 => concatenateAddressFields(suggestion_2);
    $[9] = t12;
  } else {
    t12 = $[9];
  }
  const t13 = e => {
    if (e.name && typeof props.onBlur === "function") {
      props.onBlur(e);
    }
  };
  const t14 = props.value && props.value.trim().length > 2 ? "off" : props.autoComplete;
  let t15;
  if ($[10] !== field || $[11] !== props || $[12] !== t13 || $[13] !== t14) {
    t15 = {
      ...field,
      ...props,
      onBlur: t13,
      autoComplete: t14
    };
    $[10] = field;
    $[11] = props;
    $[12] = t13;
    $[13] = t14;
    $[14] = t15;
  } else {
    t15 = $[14];
  }
  let t16;
  if ($[15] !== errorMessage || $[16] !== refField) {
    t16 = inputProps => <LabeledTextInput {...inputProps} key={inputProps?.key} label={inputProps.placeholder} placeholder="" errorMessage={errorMessage} ref={refField} />;
    $[15] = errorMessage;
    $[16] = refField;
    $[17] = t16;
  } else {
    t16 = $[17];
  }
  let t17;
  if ($[18] !== T0 || $[19] !== clearSuggestions || $[20] !== onSuggestionSelected || $[21] !== onSuggestionsFetchRequested || $[22] !== suggestions || $[23] !== t10 || $[24] !== t11 || $[25] !== t12 || $[26] !== t15 || $[27] !== t16) {
    t17 = <T0 suggestions={suggestions} onSuggestionsFetchRequested={onSuggestionsFetchRequested} onSuggestionsClearRequested={clearSuggestions} onSuggestionSelected={onSuggestionSelected} focusInputOnSuggestionClick={t9} shouldRenderSuggestions={t10} getSuggestionValue={t11} renderSuggestion={t12} inputProps={t15} renderInputComponent={t16} />;
    $[18] = T0;
    $[19] = clearSuggestions;
    $[20] = onSuggestionSelected;
    $[21] = onSuggestionsFetchRequested;
    $[22] = suggestions;
    $[23] = t10;
    $[24] = t11;
    $[25] = t12;
    $[26] = t15;
    $[27] = t16;
    $[28] = t17;
  } else {
    t17 = $[28];
  }
  return t17;
};
BaseField.propTypes = {
  value: PropTypes.string,
  field: PropTypes.shape({
    name: PropTypes.string,
    value: PropTypes.string
  }),
  errorMessage: PropTypes.string,
  placeholder: PropTypes.string,
  autoComplete: PropTypes.string,
  setFieldValue: PropTypes.func,
  addressFieldName: PropTypes.string,
  stateFieldName: PropTypes.string,
  cityFieldName: PropTypes.string,
  zipCodeFieldName: PropTypes.string,
  refField: PropTypes.node,
  onBlur: PropTypes.func
};
export default BaseField;
function _temp(suggestion_0) {
  const suggestionLabel = [];
  suggestionLabel.push(suggestion_0?.street_line);
  suggestionLabel.push(suggestion_0?.city);
  suggestionLabel.push(suggestion_0?.state);
  return suggestionLabel.filter(Boolean).join(", ");
}
function _temp2(value_0) {
  return value_0 && value_0.trim().length > 2;
}
function _temp3(suggestion_1) {
  return suggestion_1;
}